var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEmptyFileOutline = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 32 32",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M18.667 2.667H8a2.663 2.663 0 0 0-2.653 2.666l-.014 21.334a2.663 2.663 0 0 0 2.654 2.666H24c1.467 0 2.667-1.2 2.667-2.666v-16l-8-8ZM8 26.667V5.333h9.334V12H24v14.667H8Z"
})));
export default SvgEmptyFileOutline;